module.exports = __webpack_public_path__ + "2b115126e0d4585745826c3fa4d03c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/lao/03.jpg
// module id = nb2B
// module chunks = 0